import React from 'react';

import styles from './chartTooltipPriceStyles';

const ChartTooltipPrice = ({ price, currency, symbol, date }) => {
  return (
    <div className={styles.priceTooltip}>
      <div>
        <strong>{symbol}</strong> {date}
      </div>
      <div>
        <strong>Closing Price:</strong> {price} {currency}
      </div>
    </div>
  );
};

export default ChartTooltipPrice;
